import { useEffect } from "react";
import { useLocation } from "react-router";

/** Ce composant scrolle en haut de la page à la navigation. */
export function useScrollToTop(): null {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
}
